export function getEnvironmentVariable(name: string): string {
  const value = process.env[name];

  if (value === undefined || value === null) {
    throw new Error('Missing environment variable: ' + name);
  }

  return value;
}
